import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { MaterialModule } from '../modules/material.module';
import { DirectivesModule } from '../shared/modules/directives.module';
import { SelectMobileDialogComponent } from './header/select-mobile-dialog/select-mobile-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { RejectedRequestComponent } from './header/rejected-request/rejected-request.component';
import { ApplicationAlertComponent } from './header/application-alert/application-alert.component';
import { AddComponentSupplyComponent } from './header/add-component-supply/add-component-supply.component';
import { RejectNotificationComponent } from './header/reject-notification/reject-notification.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  imports: [CommonModule, BsDatepickerModule, NgxMaterialTimepickerModule, RouterModule, FormsModule,
     ReactiveFormsModule, DirectivesModule, MaterialModule, NgSelectModule, NgxMaskDirective, NgxMaskPipe, FontAwesomeModule,
      AccordionModule.forRoot(),
      PopoverModule],
  declarations: [
    SelectMobileDialogComponent,
    AddComponentSupplyComponent,
    RejectedRequestComponent,
    ApplicationAlertComponent,
    RejectNotificationComponent,
  ],
  providers: [
    provideNgxMask()
  ],
  exports: [NgSelectModule,MatDialogModule]

})
export class AppCommonModule { }
